<template>
  <div class="account-references-header flex">
    <div class="account-references-header-left">
      <div class="account-reference-search-container">
        <acclaro-input placeholder="Search by Reference Name"
                       :v-model="searchTerm"
                       @input="this.searchTermInput"
        />
      </div>
      <div>
        <button id="add-account-reference" class="acclaro-hollow-btn" @click="showCreateModal"><i class="acclaro-icon ai-add add-icon"></i>
          <span>Add Account Reference</span>
        </button>
      </div>
    </div>
    <div class="account-references-header-right">
      <b>Total</b>: {{ this.stats.total }} &nbsp;•&nbsp; <b>Shared</b>: {{ this.stats.shared }} &nbsp;•&nbsp;
      <b>Private</b>:
      {{
        this.stats.private
      }}
    </div>
  </div>
</template>

<script>
import AcclaroInput from "../Micro-Components/Acclaro-Input/Acclaro-Input";
import {mapActions, mapGetters, mapMutations} from "vuex";
import './references.scss';


export default {
  name: "AccountReferenceHeader",
  props: ['stats'],
  components: {
    AcclaroInput,
  },
  computed: {
    ...mapGetters('AccountReferencesStore', [
      'requestUrl'
    ]),
    searchTerm: {
      get () {
        return this.$store.state.AccountReferencesStore.searchTerm;
      },
      set (value) {
        this.setSearchTerm(value);
        this.setCurrentPage({
          url: undefined, //unused
          page: 1
        });
        if (value.length === 0 || value.length > 2) {
          this.fetchReferences();
        }
      }
    }
  },
  methods: {
    ...mapMutations('AccountReferencesStore', [
      'setSearchTerm',
      'setCurrentPage',
      'updateReferenceModalShow',
      'updateReferenceModalMode',
    ]),
    ...mapActions('AccountReferencesStore', [
      'fetchReferences',
    ]),
    searchTermInput (value) {
      this.setCurrentPage({
        url: undefined, //unused
        page: 1
      });
      this.setSearchTerm(value);
      if (value.length === 0 || value.length > 2) {
        this.fetchReferences(this.requestUrl);
      }
    },
    showCreateModal () {
      this.updateReferenceModalShow(true);
      this.updateReferenceModalMode("create");
    },
  }
};
</script>
